export enum DocumentStatus {
  TOUT = -1,
  EN_ATTENTE = 0,
  VALIDE = 1,
  REJETE = 2,
  ARCHIVE = 3,
}

const DocumentStatusConfig = {
  [DocumentStatus.TOUT]: {
    label: "Tout",
    icon: "bi-hourglass-split",
    color: "white",
  },
  [DocumentStatus.EN_ATTENTE]: {
    label: "En attente",
    icon: "bi-hourglass-split",
    color: "#F39C12",
  },
  [DocumentStatus.VALIDE]: {
    label: "Validé",
    icon: "bi-check-circle",
    color: "#00A86B",
  },
  [DocumentStatus.REJETE]: {
    label: "Rejeté",
    icon: "bi-x-circle",
    color: "#E74C3C",
  },
  [DocumentStatus.ARCHIVE]: {
    label: "Archivé",
    icon: "bi-archive",
    color: "#7F8C8D",
  },
} as const;

export const statusToLabel = (status: number): string =>
  DocumentStatusConfig[status as DocumentStatus]?.label ?? "Inconnu";

export const StatusBadge: React.FC<{ statut: DocumentStatus }> = ({ statut }) => {
  const config = DocumentStatusConfig[statut];

  if (!config) return null;

  return (
    <label className="tech-btn-status">
      <i
        className={`bi ${config.icon}`}
        style={{ color: config.color }}
      ></i>
      {config.label}
    </label>
  );
};
